import userConstants from "../_constants/userConstants";
import userService from "../_services/userService";
import { auth, LOCAL, realtimeDB, TIMESTAMP, firestore } from "../_firebase";
import { showToast } from "./appActions";
import Collection from "../_collections";
import { updateObject } from "../_utils";

/* ---------------------------------------------------
    IS USER ALREADY LOGGED IN
----------------------------------------------------- */
export const isUserAlreadyLoggedIn = payload => dispatch => {
  const { url } = payload;
  //verify is user logged in or not
  auth.onAuthStateChanged(user => {
    if (user) {
      dispatch(
        authenticationSuccessfull({ url, user: userService.getUserInfo(user) })
      );

      
    } else {
      dispatch(authenticationFailed({ code: null, message: null }));
    }
  });
};

/* ---------------------------------------------------
    AUTHENTICATE USER
----------------------------------------------------- */
export const authenticateUser = payload => dispatch => {
  const { email, password } = payload;
  dispatch(authenticationStarted());

  userService.login(email, password).catch(error => {
    dispatch(authenticationFailed(error));
    dispatch(showToast({ type: "danger", message: error.message }));
  });
};

/* ---------------------------------------------------
    AUTHENTICATION STARTED
----------------------------------------------------- */
const authenticationStarted = payload => ({
  type: userConstants.AUTHENTICATION_STARTED,
  payload
});

/* ---------------------------------------------------
    AUTHENTICATION SUCCESSFULL
----------------------------------------------------- */
const authenticationSuccessfull = payload => ({
  type: userConstants.AUTHENTICATION_SUCCESSFULL,
  payload
});

/* ---------------------------------------------------
    AUTHENTICATION FAILED
----------------------------------------------------- */
const authenticationFailed = payload => ({
  type: userConstants.AUTHENTICATION_FAILED,
  payload
});

/* ---------------------------------------------------
    SIGN OUT
----------------------------------------------------- */
export const signOut = payload => dispatch => {
  userService.logout().then(() => {
    dispatch(signOutSuccess());
  });
};

/* ---------------------------------------------------
   SIGN OUT SUCCESS
----------------------------------------------------- */
const signOutSuccess = payload => ({
  type: userConstants.SIGN_OUT,
  payload
});

/* ---------------------------------------------------
    CREATE ACCOUNT
----------------------------------------------------- */
export const createAccount = payload => dispatch => {
  const { email, password, onSuccess, onError } = payload;
  userService
    .signup(email, password)
    .then(user => {
      onSuccess ? onSuccess(user) : null;
      dispatch(newAccountCreated());
    })
    .catch(error => {
      onError ? onError(error) : null;
      dispatch(showToast({ type: "danger", message: error.message }));
    });
};

/* ---------------------------------------------------
   NEW ACCOUNT CREATED
----------------------------------------------------- */
const newAccountCreated = payload => ({
  type: userConstants.NEW_ACCOUNT_CREATED,
  payload
});

/* ---------------------------------------------------
    GET PARTNER PREFERENCE
----------------------------------------------------- */
export const getPartnerPreference = payload => dispatch => {
  const userId = auth.currentUser.uid;
  const unsubscribe = firestore
    .collection(Collection.USERS)
    .doc(userId)
    .collection(Collection.PARTNER_PREFERENCE)
    .doc(userId)
    .onSnapshot(doc => {
      if (doc.exists) {
        dispatch(getPartnerPreferenceSuccess(doc.data()));
      } else {
        dispatch(getPartnerPreferenceSuccess({}));
      }
    });

  return unsubscribe;
};
/* ---------------------------------------------------
   GET PARTNER PREFERENCE SUCCESS
----------------------------------------------------- */
const getPartnerPreferenceSuccess = payload => ({
  type: userConstants.GET_PARTNER_PREFERENCE,
  payload
});

/* ---------------------------------------------------
    UPDATE PARTNER PREFERENCE
----------------------------------------------------- */
export const updatePartnerPreference = payload => dispatch => {
  const { data, previous, onSuccess, onError } = payload;

  userService
    .updatePartnerPreference(data, previous)
    .then(response => {
      if (onSuccess) {
        onSuccess();
      }
      dispatch(updatePartnerPreferenceSuccess());
    })
    .catch(err => {
      if (onError) {
        onError(err);
      }
    });
};

/* ---------------------------------------------------
   UPDATE PARTNER PREFERENCE SUCCESS
----------------------------------------------------- */
const updatePartnerPreferenceSuccess = payload => ({
  type: userConstants.UPDATE_PARTNER_PREFERENCE,
  payload
});

/* ---------------------------------------------------
    GET USER PROFILE
----------------------------------------------------- */
export const getUserProfile = payload => dispatch => {
  const userId = auth.currentUser.uid;
  const unsubscribeUserProfile = firestore
    .collection(Collection.USERS)
    .doc(userId)
    .onSnapshot(doc => {
      if (doc.exists) {
        dispatch(getUserProfileSuccess(doc.data()));
      } else {
        dispatch(getUserProfileSuccess({}));
      }
    });

  return unsubscribeUserProfile;
};

/* ---------------------------------------------------
    GET MOBILE NUMBER
----------------------------------------------------- */
export const getMobileNumber = payload => dispatch => {
  const userId = auth.currentUser.uid;
  const unsubscribeMobileNumber = firestore
    .collection(Collection.USERS)
    .doc(userId)
    .collection(Collection.PHONE_NUMBER)
    .doc(userId)
    .onSnapshot(doc => {
      if (doc.exists) {
        dispatch(getMobileNumberSuccess(doc.data()));
      } else {
        dispatch(getMobileNumberSuccess({ mobile: "" }));
      }
    });

  return unsubscribeMobileNumber;
};
/* ---------------------------------------------------
   GET MOBILE NUMBER SUCCESS
----------------------------------------------------- */
const getMobileNumberSuccess = payload => ({
  type: userConstants.GET_MOBILE_NUMBER,
  payload
});

/* ---------------------------------------------------
   GET USER PROFILE SUCCESS
----------------------------------------------------- */
const getUserProfileSuccess = payload => ({
  type: userConstants.GET_USER_PROFILE,
  payload
});

/* ---------------------------------------------------
    UPDATE USER GENDER
----------------------------------------------------- */
export const updateUserGender = payload => dispatch => {
  const { name, isFemale, createdBy, onError } = payload;

  userService
    .updateNameGenderAndCreatedBy(name, isFemale, createdBy)
    .then(() => {
      dispatch(getUserInformation());
    })
    .catch(err => {
      if (onError) {
        onError(err);
      }
    });
};
/* ---------------------------------------------------
   GET USER INFORMATION
----------------------------------------------------- */
const getUserInformation = payload => ({
  type: userConstants.GET_USER_INFORMATION,
  payload: { user: userService.getUserInfo(auth.currentUser) }
});
/* ---------------------------------------------------
    UPDATE USER PROFILE
----------------------------------------------------- */
export const updateUserProfile = payload => dispatch => {
  const { data, onSuccess, onError } = payload;

  userService
    .updateUserProfile(data)
    .then(() => {
      dispatch(updateUserProfileSuccess());
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError(err);
      }
    });
};

/* ---------------------------------------------------
   UPDATE USER PROFILE 
----------------------------------------------------- */
const updateUserProfileSuccess = payload => ({
  type: userConstants.UPDATE_USER_PROFILE,
  payload
});

/* ---------------------------------------------------
    GET PRIVACY SETTING
----------------------------------------------------- */
export const getPrivacySetting = payload => dispatch => {
  const userId = auth.currentUser.uid;
  let unsubscribePrivacy = firestore
    .collection(Collection.USERS)
    .doc(userId)
    .collection(Collection.PRIVACY_SETTING)
    .doc(userId)
    .onSnapshot(doc => {
      if (doc.exists) {
        dispatch(getPrivacySettingSuccess(doc.data()));
      } else {
        dispatch(getPrivacySettingSuccess({}));
      }
    });

  return unsubscribePrivacy;
};

/* ---------------------------------------------------
   GET PRIVACY SETTING SUCCESS
----------------------------------------------------- */
const getPrivacySettingSuccess = payload => ({
  type: userConstants.GET_PRIVACY_SETTING,
  payload
});

/* ---------------------------------------------------
    UPDATE PRIVACY SETTING
----------------------------------------------------- */
export const updatePrivacySetting = payload => dispatch => {
  const { data, onSuccess, onError } = payload;

  userService
    .updatePrivacy(data)
    .then(() => {
      dispatch(updatePrivacySettingSuccess());
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError(err);
      }
    });
};

/* ---------------------------------------------------
   GET PRIVACY SETTING SUCCESS
----------------------------------------------------- */
const updatePrivacySettingSuccess = payload => ({
  type: userConstants.UPDATE_PRIVACY_SETTING,
  payload
});

/* ---------------------------------------------------
    UPLOAD PROFILE PICTURE
----------------------------------------------------- */
export const uploadProfilePicture = payload => dispatch => {
  const { image, onSuccess, onError } = payload;

  userService
    .updateProfilePicture(image)
    .then(url => {
      dispatch(uploadProfilePictureSuccess(url));
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError(err);
      }
    });
};

/* ---------------------------------------------------
   UPLOAD PROFILE PICTURE SUCCESS
----------------------------------------------------- */
const uploadProfilePictureSuccess = payload => ({
  type: userConstants.UPLOAD_PROFILE_PICTURE,
  payload
});

/* ---------------------------------------------------
    REMOVE PROFILE PICTURE
----------------------------------------------------- */
export const removeProfilePicture = payload => dispatch => {
  const { isFemale, onSuccess, onError } = payload;

  userService
    .removeProfilePicture(isFemale)
    .then(() => {
      dispatch(removeProfilePictureSuccess());
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError(err);
      }
    });
};

/* ---------------------------------------------------
   REMOVE PROFILE PICTURE SUCCESS
----------------------------------------------------- */
const removeProfilePictureSuccess = payload => ({
  type: userConstants.REMOVE_PROFILE_PICTURE,
  payload
});

/* ---------------------------------------------------
  GET TOP CONNECTED MEMBERS 
----------------------------------------------------- */
export const getTopConnectedMembers = payload => dispatch => {
  userService
    .getTopConnected()
    .then(response => {
      dispatch(getTopConnectedMembersSuccess(response));
    })
    .catch(err => {
      dispatch(getTopConnectedMembersSuccess([]));
    });
};

/* ---------------------------------------------------
  GET TOP CONNECTED MEMBERS SUCCESS
----------------------------------------------------- */
const getTopConnectedMembersSuccess = payload => ({
  type: userConstants.GET_TOP_CONNECTED_MEMBERS,
  payload
});

/* ---------------------------------------------------
  GET GALLERY IMAGES
----------------------------------------------------- */
export const getGalleryImages = payload => dispatch => {
  const userId = auth.currentUser.uid;

  return firestore
    .collection(Collection.USERS)
    .doc(userId)
    .collection(Collection.GALLERY)
    .orderBy("createdAt", "desc")
    .onSnapshot(snapshot => {
      let images = [];
      snapshot.forEach(result => {
        images.push({ ...result.data(), ...{ id: result.id } });
      });
      dispatch(getGalleryImagesSuccess(images));
    });
};

/* ---------------------------------------------------
  GET GALLERY IMAGES SUCCESS
----------------------------------------------------- */
const getGalleryImagesSuccess = payload => ({
  type: userConstants.GET_GALLERY_IMAGES,
  payload
});

/* ---------------------------------------------------
    UPLOAD GALLERY IMAGES
----------------------------------------------------- */
export const uploadGalleryImages = payload => dispatch => {
  const { images } = payload;

  userService.uploadImages(images);
};

/* ---------------------------------------------------
  UPDATE PROFILE PICTURE
----------------------------------------------------- */
export const updateProfilePicture = payload => dispatch => {
  const { url, onSuccess, onError } = payload;
  userService
    .changeProfilePicture(url)
    .then(response => {
      dispatch(updateProfilePictureSuccess(response));
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError(err);
      }
    });
};

/* ---------------------------------------------------
  UPDATE PROFILE PICTURE SUCCESS
----------------------------------------------------- */
const updateProfilePictureSuccess = payload => ({
  type: userConstants.UPDATE_PROFILE_PICTURE,
  payload
});

/* ---------------------------------------------------
  DELETE GALLERY IMAGES
----------------------------------------------------- */
export const deleteGalleryImages = payload => dispatch => {
  const { images, onSuccess, onError } = payload;
  userService
    .deleteImages(images)
    .then(response => {
      dispatch(deleteGalleryImagesSuccess(response));
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError(err);
      }
    });
};

/* ---------------------------------------------------
  DELETE GALLERY IMAGES SUCCESS
----------------------------------------------------- */
const deleteGalleryImagesSuccess = payload => ({
  type: userConstants.DELETE_GALLERY_IMAGES,
  payload
});

/* ---------------------------------------------------
    UPDATE USER GENDER
----------------------------------------------------- */
export const updateMyInformation = payload => dispatch => {
  const { name, createdBy, mobile, onError } = payload;

  userService
    .updateMyInformation(name, mobile, createdBy)
    .then(() => {
      dispatch(getUserInformation());
    })
    .catch(err => {
      if (onError) {
        onError(err);
      }
    });
};

/* ---------------------------------------------------
    GET NEW JOINED MEMBERS
----------------------------------------------------- */
export const getNewJoinedMembers = gender => dispatch => {
  const unsubscribeNewJoinedMembers = firestore
    .collection(Collection.USERS)
    .where("isFemale", "==", !gender)
    .orderBy("createdAt", "desc")
    .limit(3)
    .onSnapshot(results => {
      let memberResults = [];

      results.forEach(result => {
        memberResults.push(updateObject(result.data(), { id: result.id }));
      });

      dispatch(getNewJoinedMembersSuccess(memberResults));
    });

  return () => {
    unsubscribeNewJoinedMembers();
    dispatch(clearNewJoinedMembers());
  };
};
/* ---------------------------------------------------
   GET NEW JOINED MEMBERS SUCCESS
----------------------------------------------------- */
const getNewJoinedMembersSuccess = payload => ({
  type: userConstants.GET_NEW_JOINED_MEMBERS,
  payload
});

/* ---------------------------------------------------
   CLEAR NEW JOINED MEMBERS
----------------------------------------------------- */
const clearNewJoinedMembers = payload => ({
  type: userConstants.CLEAR_NEW_JOINED_MEMBERS,
  payload
});

/* ---------------------------------------------------
    GET TOP PROFILE VISITORS
----------------------------------------------------- */
export const getTopProfileVisitors = () => dispatch => {
  const userId = auth.currentUser.uid;
  const unsubscribeProfileVisitors = firestore
    .collection("admin")
    .doc('4skmNiROg9ziez0oPlHz')
    .onSnapshot(doc => {
      if (doc.exists) {
        dispatch(getTopProfileVisitorsSuccess(doc.data()));
      } else {
        dispatch(getTopProfileVisitorsSuccess({}));
      }
    });

  return () => {
    unsubscribeProfileVisitors();
    dispatch(clearTopProfileVisitors());
  };
};
/* ---------------------------------------------------
   GET TOP PROFILE VISITORS SUCCESS
----------------------------------------------------- */
const getTopProfileVisitorsSuccess = payload => ({
  type: userConstants.GET_TOP_PROFILE_VISITORS,
  payload
});

/* ---------------------------------------------------
   CLEAR TOP PROFILE VISITORS
----------------------------------------------------- */
const clearTopProfileVisitors = payload => ({
  type: userConstants.CLEAR_TOP_PROFILE_VISITORS,
  payload
});

/* ---------------------------------------------------
    DELETE USER
----------------------------------------------------- */
export const deleteUser = () => dispatch => {
  userService
    .deleteMe()
    .then(response => {
      dispatch(deleteUserSuccess(response));
    })
    .catch(err => {});
};
/* ---------------------------------------------------
   DELETE USER SUCCESS
----------------------------------------------------- */
const deleteUserSuccess = payload => ({
  type: userConstants.DELETE_USER,
  payload
});
/* ---------------------------------------------------
    RE AUTHENTICATE USER
----------------------------------------------------- */
export const reAuthenticateUser = payload => dispatch => {
  const { email, password, onSuccess, onError } = payload;
  userService
    .reAuthenticate(email, password)
    .then(response => {
      dispatch(reAuthenticateUserSuccess(response));
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError(err);
      }
    });
};
/* ---------------------------------------------------
   RE AUTHENTICATE USER SUCCESS
----------------------------------------------------- */
const reAuthenticateUserSuccess = payload => ({
  type: userConstants.RE_AUTHENTICATE_USER,
  payload
});
/* ---------------------------------------------------
    RESET PASSWORD
----------------------------------------------------- */
export const resetPassword = payload => dispatch => {
  const { password, onSuccess, onError } = payload;
  userService
    .resetPassword(password)
    .then(response => {
      dispatch(resetPasswordSuccess(response));
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError(err);
      }
    });
};
/* ---------------------------------------------------
   RESET PASSWORD SUCCESS
----------------------------------------------------- */
const resetPasswordSuccess = payload => ({
  type: userConstants.RESET_PASSWORD,
  payload
});

/* ---------------------------------------------------
    FORGOT PASSWORD
----------------------------------------------------- */
export const forgotPassword = payload => dispatch => {
  const { email, onSuccess, onError } = payload;
  userService
    .forgotPassword(email)
    .then(response => {
      dispatch(forgotPasswordSuccess(response));
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(err => {
      if (onError) {
        onError(err);
      }
    });
};
/* ---------------------------------------------------
   FORGOT PASSWORD SUCCESS
----------------------------------------------------- */
const forgotPasswordSuccess = payload => ({
  type: userConstants.FORGOT_PASSWORD,
  payload
});



// WEBPACK FOOTER //
// ./src/_actions/userActions.js